import styled, { CSSProp, css } from "styled-components";

export const ErrorWrapper = styled.div<{ remSize?: number; pTagCss?: CSSProp }>`
  width: 100% !important;
  p {
    color: #d32f2f !important;
    font-weight: 500;
    text-align: center;
    font-size: ${(props) => `${props.remSize}rem` || "0.75rem"};
    ${(props) => props.pTagCss}
  }
`;

export const customScroll = css`

  scrollbar-width: thin;
  scrollbar-color: #404040 #ffffff;

  /* Chrome, Edge, and Safari */
  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: #ffffff;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #000;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #404040;

    border: 0px none #ffffff;
  }
`